import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "arrow", "label"]

  connect() {
    this.isSidebarOpen = false
    // Restore collapsed state from localStorage
    this.isCollapsed = localStorage.getItem('crm_sidebar_collapsed') === 'true'
    if (this.isCollapsed && this.hasSidebarTarget) {
      this.applyCollapsed()
    }
    document.addEventListener('mobile-menu-toggled', this.handleMobileMenuToggle.bind(this))
  }

  disconnect() {
    document.removeEventListener('mobile-menu-toggled', this.handleMobileMenuToggle.bind(this))
  }

  handleMobileMenuToggle(event) {
    this.toggle()
  }

  toggle() {
    if (this.isSidebarOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  // Desktop: collapse/expand (icons only vs full)
  collapse() {
    this.isCollapsed = !this.isCollapsed
    localStorage.setItem('crm_sidebar_collapsed', this.isCollapsed)
    if (this.isCollapsed) {
      this.applyCollapsed()
    } else {
      this.applyExpanded()
    }
  }

  applyCollapsed() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.add('crm-sidebar-collapsed')
    this.sidebarTarget.classList.remove('crm-sidebar-expanded')
    this.labelTargets.forEach(el => el.classList.add('lg:hidden'))
    // Set title tooltips from label text
    this.sidebarTarget.querySelectorAll('nav a').forEach(a => {
      const label = a.querySelector('[data-sidebar-toggle-target="label"]')
      if (label) a.setAttribute('title', label.textContent.trim())
    })
  }

  applyExpanded() {
    if (!this.hasSidebarTarget) return
    this.sidebarTarget.classList.remove('crm-sidebar-collapsed')
    this.sidebarTarget.classList.add('crm-sidebar-expanded')
    this.labelTargets.forEach(el => el.classList.remove('lg:hidden'))
    // Remove title tooltips
    this.sidebarTarget.querySelectorAll('nav a[title]').forEach(a => a.removeAttribute('title'))
  }

  // Mobile: slide in/out
  open() {
    this.isSidebarOpen = true
    const sidebar = this.sidebarTarget
    const overlay = this.overlayTarget

    sidebar.classList.remove('-translate-x-full', 'hidden')
    sidebar.classList.add('translate-x-0', 'lg:block')

    if (this.hasArrowTarget) {
      this.arrowTarget.style.transform = 'rotate(180deg)'
    }

    if (window.innerWidth < 1024) {
      overlay.classList.remove('hidden')
    }
  }

  close() {
    this.isSidebarOpen = false
    const sidebar = this.sidebarTarget
    const overlay = this.overlayTarget

    sidebar.classList.add('-translate-x-full', 'hidden')
    sidebar.classList.remove('translate-x-0', 'lg:block')

    if (this.hasArrowTarget) {
      this.arrowTarget.style.transform = 'rotate(0deg)'
    }

    overlay.classList.add('hidden')
  }
}
